import { render, staticRenderFns } from "./Radios.vue?vue&type=template&id=c486ec52"
import script from "./Radios.vue?vue&type=script&lang=js"
export * from "./Radios.vue?vue&type=script&lang=js"
import style0 from "./Radios.vue?vue&type=style&index=0&id=c486ec52&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports